<template>
  <section class="pagination-section">
    <b-pagination
      :total="totalItems"
      v-model="currentPage"
      :per-page="perPage"
      range-before="3"
      range-after="1"
      @change="handlePageChange"
    >
      <template #previous="props">
        <b-pagination-button :page="props.page">
          Anterior
        </b-pagination-button>
      </template>

      <template #default="props">
        <b-pagination-button :page="props.page">
          {{ props.page.number }}
        </b-pagination-button>
      </template>

      <template #next="props">
        <b-pagination-button :page="props.page">
          Próximo
        </b-pagination-button>
      </template>
    </b-pagination>

    <div class="total-registros mt-3">
      <b>Total de Registros:</b> {{ totalItems }}
    </div>
  </section>
</template>

<script>
export default {
  name: 'PaginationSection',
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    totalItems: {
      type: Number,
      required: true
    },
    perPage: {
      type: Number,
      default: 15
    },
    currentQuery: {
      type: Object,
      required: true
    }
  },
  methods: {
    handlePageChange(page) {
      this.$emit('page-change', page);
    }
  }
};
</script>

<style scoped>
.pagination-section {
  margin: 15px;
}
.total-registros {
  font-size: 0.9rem;
  color: #363636;
}
</style>